module.exports = __webpack_public_path__ + "static/media/12.095b187f.jpg";